<template>
  <div class="wrapper">
    <meheader />
    <div class="content-wrapper1" style="background-color: #f7f8fa">
      <div class="invert-wrapper">
        <div>
          <router-link to="/index/mechanism/ClueEntry" tag="a">
            <img src="@/assets/imgs/组11.png" alt="" />
          </router-link>
        </div>
        <div>
          <router-link to="/index/mechanism/MyProject" tag="a">
            <img src="@/assets/imgs/我的项目.png" alt="" />
          </router-link>
        </div>
        <div>
          <router-link to="/index/mechanism/OutputValue" tag="a">
            <img src="@/assets/imgs/产值上报.png" alt="" />
          </router-link>
        </div>
      </div>
    </div>
    <van-tabbar fixed route>
      <van-tabbar-item replace to="/index/mechanism">
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('@/assets/imgs/首页-选中.png')
                : require('@/assets/imgs/首页-未选中.png')
            "
          />
        </template>
        <span> 项目管理 </span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/index/mechanism/MyCenter">
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('@/assets/imgs/我的-选中.png')
                : require('@/assets/imgs/我的-未选中.png')
            "
          />
        </template>
        <span> 我的 </span>
      </van-tabbar-item>
    </van-tabbar>
    <router-view></router-view>
  </div>
</template>
<script>
import meheader from "@/components/meheader";
export default {
  components: {
    meheader,
  },
  name: "mechanism",
  data() {
    return {
      visible: true,
    };
  },
  methods: {},
  created() {
    this.$store.dispatch("user").then(() => {
      console.log(this.$store.getters["user"]);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.header {
  background: #ffff;
}
.font-wrapper {
  width: 100px;
  display: flex;
  justify-content: space-between;
}
.wrapper {
  width: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.content-wrapper1 {
  width: 100%;
  position: absolute;
  top: 46px;
  bottom: 50px;
  .invert-wrapper {
    @include columnCenter;
    @include absCenter;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    margin-top: 40px;
    div {
      text-align: center;
      img {
        width: 90%;
      }
    }
  }
}
</style>
